module.exports = __webpack_public_path__ + "img/brombeer_ipad.5b959a9d.png";